<template>
    <img
        v-if="prismicImage && prismicImage.url"
        :src="prismicImage.url"
        :loading="loading"
        :alt="prismicImage.alt || ''"
        :height="height || prismicImage.dimensions?.height"
        :width="width || prismicImage.dimensions?.width"
    />
</template>

<script setup lang="ts">
    type PrismicImage =
        | {
              url?: null;
              dimensions?: null;
              alt?: null;
              copyright?: null;
          }
        | {
              url: string;
              dimensions: {
                  width: number;
                  height: number;
              };
              alt?: string | null;
              copyright?: string | null;
          };

    type Props = {
        loading?: 'eager' | 'lazy';
        prismicImage: PrismicImage;
        height: string;
        width: string;
    };
    withDefaults(defineProps<Props>(), {loading: 'lazy'});
</script>
